var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"spacer",staticClass:"ortic-action-toolbar-spacer"}),_vm._v(" "),_c('div',{ref:"toolbar",staticClass:"ortic-action-toolbar d-flex z-999"},[_c('div',{staticClass:"d-none d-md-block brand-indent"}),_vm._v(" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }